<div id="container">
    <div *ngIf="header" id="header">{{ header }}</div>
    <div id="content">
        <ng-content #name></ng-content>
    </div>
</div>
